export const clickNavToggler = () => {
  const togglb = document.querySelector("#togb");
  if (window.getComputedStyle(togglb).display !== "none") togglb.click();
};
